import { WebPlatform } from "@linkfluence/models/platform";
import { getFaviconUrl } from "@radarly/api/project";
import { InfluencerLens } from "./generic";
import { Audience, GenericInfluencer, Geo, InfluencerAccountMetric } from ".";

type WebInfluencerPlatform = Exclude<WebPlatform, "comment">;
export interface WebInfluencer
  extends GenericInfluencer<WebInfluencerPlatform> {
  email: string[];
  audience: Audience;
  reversed: string;
  url: string;
  lang: string;
  lf: number;
  pr: number;
  topic: { category: string; value: number }[];
  geo: Geo;
}

export class WebInfluencerLens extends InfluencerLens<WebInfluencer> {
  public getId(): string {
    return this.influencer.reversed;
  }
  public getPermalink(): string {
    return this.influencer.url;
  }

  public getName(): string {
    return String(this.influencer.url || "").replace(/^(https?):\/\//, "");
  }

  public getScreenName(): string {
    return this.influencer.url;
  }

  public getAvatar(): string {
    return getFaviconUrl(
      this.influencer.url,
      "small",
      this.influencer.platform
    );
  }
  public getCountry(): string {
    return this.influencer.geo.country;
  }
  public getAccountMetrics(): InfluencerAccountMetric[] {
    return [
      {
        key: "AVERAGE_TRAFFIC",
        value: this.influencer.audience.meanTraffic,
      },
      { key: "PAGE_RANK", value: this.influencer.pr },
      { key: "COUNTRY", value: this.influencer.geo.country },
    ];
  }
  public getQuery(): string {
    return `url.site.reversed:"${this.influencer.reversed}"`;
  }
}
